import { createAction } from '@mendeley-internal/lib-js-redux-actions';

export const login = createAction('LOGIN');

export const signInToAddToLibrary = createAction(
  'SIGN_IN_TO_ADD_TO_LIBRARY',
  id => ({ id }),
);

export const signInToViewPdf = createAction(
  'SIGN_IN_TO_VIEW_PDF',
  id => ({ id }),
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/session.js